import { ExpandMoreOutlined } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Collapse,
  Divider,
} from '@mui/material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { BomItemType } from 'model/Project/BoMItemRow'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import React, { useState } from 'react'
import { ModelController } from '../manager/ModelController'
import { AngleMeasurementTool } from './AngleMeasurementTool'
import { BoundingBoxTool } from './BoundingBoxTool'
import { DisplayModeTool } from './DisplayMode'
import { DistanceMeasurementTool } from './DistanceMeasurementTool'
import { ExplodeTool } from './ExplodeTool'
import { FitAllTool } from './FitAllTool'
import { SelectionMode } from './SelectionMode'
import { UnitSelectorTool } from './UnitSystemTool'

type Props = {
  bomItemPointer: BomItemPointer
  viewController: ModelController
}

export const ViewerTools = (props: Props) => {
  const [HelpComponent, setHelpComponent] = useState<
    React.ReactElement<any> | undefined
  >(null)

  return (
    <Box
      sx={{
        position: 'absolute',
        zIndex: 10,
        width: (theme) => theme.spacing(50),
      }}
    >
      <Accordion
        defaultExpanded={false}
        elevation={0}
        sx={{
          opacity: 0.8,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreOutlined />}
          onClick={(e) => e.stopPropagation()}
          sx={{
            '& .MuiAccordionSummary-content': {
              display: 'flex',
              flexWrap: 'wrap',
              gap: (theme) => theme.spacing(1),
            },
          }}
        >
          <div style={{ display: 'flex', width: '100%', gap: '1em' }}>
            <FitAllTool viewManager={props.viewController} />
            <DistanceMeasurementTool
              controller={props.viewController}
              setHelpComponent={setHelpComponent}
            />
            <AngleMeasurementTool
              controller={props.viewController}
              setHelpComponent={setHelpComponent}
            />
            <BoundingBoxTool
              bomItemPointer={props.bomItemPointer}
              controller={props.viewController}
            />

            {/* <AutoMeasurementsTool
              controller={props.viewController}
              setHelpComponent={setHelpComponent}
            /> */}
            {/* <FaceMeasurementTool controller={props.viewController} /> */}
          </div>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Collapse in={Boolean(HelpComponent)}>{HelpComponent}</Collapse>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: (theme) => theme.spacing(1, 0) }}>
          <Box sx={{ p: 2, pt: 0 }}>
            <LocalizedTypography
              translationKey="project:viewer-unit-of-measure"
              variant="caption"
              color="textSecondary"
            >
              unit
            </LocalizedTypography>
            <UnitSelectorTool
              controller={props.viewController}
              bomItemPointer={props.bomItemPointer}
            />
          </Box>
          <Box sx={{ p: 2, pt: 0 }}>
            <LocalizedTypography
              translationKey="project:viewer-selection-mode"
              variant="caption"
              color="textSecondary"
            >
              selection mode
            </LocalizedTypography>
            <SelectionMode viewManager={props.viewController} />
          </Box>
          {[BomItemType.assemblyInstance, BomItemType.assemblyType].includes(
            props.bomItemPointer.type
          ) && (
            <>
              <Divider />
              <Box sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <LocalizedTypography
                  translationKey="project:viewer-explode-tool"
                  variant="caption"
                  color="textSecondary"
                >
                  exploder
                </LocalizedTypography>
                <ExplodeTool viewController={props.viewController} />
              </Box>
            </>
          )}

          <Divider />
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <LocalizedTypography
              translationKey="project:viewer-display-mode"
              variant="caption"
              color="textSecondary"
              component="p"
            >
              display mode
            </LocalizedTypography>
            <DisplayModeTool viewManager={props.viewController} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}
